/**
* Dashboard api for the home page
*/

import Dashboard from './dashboard'
import { getDashboardAccessCreds } from '@/utils/accessCreds'

export default class ReportsAPI extends Dashboard {
  constructor() {
    super()
  }
  
  async getReports(payload) {
    console.log('Starting reportsAPI.js getReports payload',payload)
    const { accessToken, accessUser } = await getDashboardAccessCreds()
    return this.api.post('/reports?user='+ accessUser + '&accessToken=' + accessToken,payload
    ).then(response => {
      return response.data
    })
  }

  /** Poll async Takings Excel job — returns { status, S3presignedurl?, error? }. */
  async getTakingsReportStatus(jobId) {
    const { accessToken, accessUser } = await getDashboardAccessCreds()
    return this.api
      .get(
        '/reports?user=' +
          accessUser +
          '&accessToken=' +
          accessToken +
          '&jobId=' +
          encodeURIComponent(jobId)
      )
      .then((response) => response.data)
  }
  
}
